//scroll-to-top
document.addEventListener("DOMContentLoaded", function () {
    const scrollBtn = document.getElementById("scrollToTop");

    window.addEventListener("scroll", function () {
      if (window.scrollY > 300) {
        scrollBtn.style.display = "block";
      } else {
        scrollBtn.style.display = "none";
      }
    });

    scrollBtn.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });


//修改chat box
// document.addEventListener('DOMContentLoaded', function() {

//     // 定義目標尺寸
//     const targetSize = '3.9rem';
//     // 定義 SVG 填充顏色
//     const svgFillColor = '#FFFFFF';

//     // 定義目標右側位置 (向右移，所以 right 值會更小)
//     const targetRightPosition = '2rem'; // 調整這個值以控制距離右側邊緣的距離
//     // 定義目標底部位置 (如果需要調整垂直位置)
//     const targetBottomPosition = '3rem'; // 調整這個值以控制距離底部的距離

//     // *** 新增：定義目標 margin (移除或調整) ***
//     const targetMargin = '0'; // 將 margin 設定為 0，或根據需要設定其他值

//     let applyStylesInterval;

//     function applyShopifyInboxStyles() {
//         const chatComponent = document.querySelector('inbox-online-store-chat');

//         if (chatComponent && chatComponent.shadowRoot) {
//             const toggleButton = chatComponent.shadowRoot.querySelector('button[data-spec="toggle-button"]');

//             if (toggleButton) {
         
//                 toggleButton.style.removeProperty('right');
//                 toggleButton.style.removeProperty('bottom');
//                 toggleButton.style.removeProperty('left');
//                 toggleButton.style.removeProperty('margin');
//                 toggleButton.style.removeProperty('margin-left'); 
//                 toggleButton.style.removeProperty('margin-right'); 
//                 toggleButton.style.removeProperty('transform'); 

//                 // --- 尺寸設定 ---
//                 toggleButton.style.setProperty('width', targetSize, 'important');
//                 toggleButton.style.setProperty('height', targetSize, 'important');
//                 toggleButton.style.setProperty('max-width', targetSize, 'important');
//                 toggleButton.style.setProperty('min-width', targetSize, 'important');
//                 toggleButton.style.setProperty('min-height', targetSize, 'important');

//                 toggleButton.style.setProperty('flex-shrink', '0', 'important');
//                 toggleButton.style.setProperty('flex-grow', '0', 'important');
//                 toggleButton.style.setProperty('flex-basis', 'auto', 'important');

//                 // 調整內部 SVG 圖示的尺寸和顏色
//                 const buttonIcon = toggleButton.querySelector('svg');
//                 if (buttonIcon) {
//                     buttonIcon.style.setProperty('width', targetSize, 'important');
//                     buttonIcon.style.setProperty('height', targetSize, 'important');
//                     buttonIcon.style.setProperty('min-width', targetSize, 'important');
//                     buttonIcon.style.setProperty('min-height', targetSize, 'important');

//                     const svgPaths = buttonIcon.querySelectorAll('path');
//                     svgPaths.forEach(path => {
//                         path.style.setProperty('fill', svgFillColor, 'important');
//                     });
//                 }

            
//                 toggleButton.style.setProperty('right', targetRightPosition, 'important');         
//                 toggleButton.style.setProperty('bottom', targetBottomPosition, 'important');
//                 toggleButton.style.setProperty('left', 'auto', 'important');
//                 toggleButton.style.setProperty('transform', 'none', 'important');
//                 toggleButton.style.setProperty('margin', targetMargin, 'important');

//                 //console.log(`Shopify Inbox 按鈕樣式已強制重新應用。設定右側位置為 ${targetRightPosition}，底部位置為 ${targetBottomPosition}，邊距為 ${targetMargin}。`);
//             }
//         }
//     }

//     const observer = new MutationObserver(function(mutations) {
//         mutations.forEach(function(mutation) {
//             if (mutation.addedNodes) {
//                 mutation.addedNodes.forEach(function(node) {
//                     if (node.nodeType === 1 && node.matches('inbox-online-store-chat')) {
//                         applyShopifyInboxStyles();
//                         if (!applyStylesInterval) {
//                             applyStylesInterval = setInterval(applyShopifyInboxStyles, 200);
//                         }
//                     }
//                 });
//             }
//         });
//     });

//     observer.observe(document.body, { childList: true, subtree: true });

//     applyShopifyInboxStyles();
//     if (!applyStylesInterval) {
//         applyStylesInterval = setInterval(applyShopifyInboxStyles, 200);
//     }

//     window.addEventListener('beforeunload', function() {
//         if (applyStylesInterval) {
//             clearInterval(applyStylesInterval);
//         }
//     });
// });


//footer mobile
document.addEventListener('DOMContentLoaded', function() {
    const menuTitles = document.querySelectorAll('.footer__custom-menu-column .footer__custom-menu-title');
    menuTitles.forEach(title => {
        title.addEventListener('click', function() {
            const menuList = this.nextElementSibling;
            if (menuList && menuList.classList.contains('footer-menu')) {
                menuList.classList.toggle('is-expanded');
                this.classList.toggle('is-expanded');
            }
        });
    });

    function handleResize() {
        if (window.innerWidth > 749) {
            menuTitles.forEach(title => {
                title.classList.remove('is-expanded'); 
            });
            const menuLists = document.querySelectorAll('.footer-menu.list-unstyled');
            menuLists.forEach(list => {
                list.classList.remove('is-expanded');
            });
        }
    }

    window.addEventListener('resize', handleResize);
    handleResize();
});


//slideshow影片顯示
document.addEventListener('DOMContentLoaded', function() {
    const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    
    const videos = document.querySelectorAll('.slideshow__video--native');
    
    videos.forEach(video => {
        const container = video.closest('.slideshow__video-container');
        const controls = container ? container.querySelector('.slideshow__video-controls') : null;
        const playButton = container ? container.querySelector('.slideshow__play-button') : null;
        
        video.style.display = 'block';
        
        function attemptAutoplay() {
            if (video.readyState >= 2) { 
                const playPromise = video.play();
                
                if (playPromise !== undefined) {
                    playPromise.then(() => {
                        console.log('影片自動播放成功');
                        if (controls) controls.style.display = 'none';
                    }).catch(error => {
                        if (isMobile && controls) {
                            controls.style.display = 'flex';
                        }
                    });
                }
            }
        }
        
        if (video.readyState >= 2) {
            attemptAutoplay();
        } else {
            video.addEventListener('loadeddata', attemptAutoplay);
            video.addEventListener('canplay', attemptAutoplay);
        }
        
        if (playButton) {
            playButton.addEventListener('click', function(e) {
                e.preventDefault();
                video.play().then(() => {
                    if (controls) controls.style.display = 'none';
                }).catch(error => {
                    console.log('手動播放失敗:', error);
                });
            });
        }
        
        video.addEventListener('error', function(e) {
            console.log('影片載入錯誤:', e);
            console.log('影片來源:', video.currentSrc);
            
            const fallbackImg = video.parentElement.querySelector('.slideshow__mobile-fallback');
            if (fallbackImg) {
                fallbackImg.style.display = 'block';
                video.style.display = 'none';
            }
        });

        // 20250729監聽測試
        // video.addEventListener('loadstart', () => console.log('開始載入影片'));
        // video.addEventListener('loadedmetadata', () => console.log('影片元數據載入完成'));
        // video.addEventListener('loadeddata', () => console.log('影片數據載入完成'));
        // video.addEventListener('canplay', () => console.log('影片可以開始播放'));
        // video.addEventListener('playing', () => console.log('影片正在播放'));
        // video.addEventListener('pause', () => console.log('影片暫停'));
    });
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target.querySelector('.slideshow__video--native');
            if (video) {
                if (entry.isIntersecting) {                  
                    video.play().catch(e => console.log('播放失敗:', e));
                } else {
                    video.pause();
                }
            }
        });
    }, {
        threshold: 0.5 
    });
    
    document.querySelectorAll('.slideshow__slide').forEach(slide => {
        observer.observe(slide);
    });
});


//影片banner hover出現按鈕--副本須更新
// document.addEventListener('DOMContentLoaded', function() {
//   const slideshowElement = document.getElementById('Slide-template--18644058144953__slideshow-3');
  
//   const targetButton = slideshowElement.querySelector('.slideshow__text-wrapper.customer_banner-buttons.banner4_buttons');

//   if (slideshowElement && targetButton) {
//     slideshowElement.addEventListener('mouseenter', function() {
//       targetButton.style.opacity = '1';
//       targetButton.style.visibility = 'visible';
//     });


//     slideshowElement.addEventListener('mouseleave', function() {
//       targetButton.style.opacity = '0';
//       targetButton.style.visibility = 'hidden';
//     });

//   } else {
//     console.warn('警告: 無法找到 #Slider-template--18539198611641__slideshow 或目標按鈕。');
//   }
// });


//影片banner hover出現按鈕--副本須更新
// document.addEventListener('DOMContentLoaded', function() {
//   const slideshowElement = document.getElementById('Slide-template--18644058144953__slideshow-5');

//   const targetButton = slideshowElement.querySelector('.slideshow__text-wrapper .customer_banner-buttons .banner6_buttons');

//   if (slideshowElement && targetButton) {
//     slideshowElement.addEventListener('mouseenter', function() {
//       targetButton.style.opacity = '1';
//       targetButton.style.visibility = 'visible';
//     });


//     slideshowElement.addEventListener('mouseleave', function() {
//       targetButton.style.opacity = '0';
//       targetButton.style.visibility = 'hidden';
//     });

//   } else {
//     console.warn('警告: 無法找到 #Slider-template--18539198611641__slideshow 或目標按鈕。');
//   }
// });


//profit sharing
// 確保追蹤參數在頁面間傳遞
function preserveTrackingCode() {
    const urlParams = new URLSearchParams(window.location.search);
    const scaRef = urlParams.get('sca_ref');
    
    if (scaRef) {
        // 將追蹤碼保存到 localStorage 或 sessionStorage
        localStorage.setItem('sca_ref', scaRef);
        
        // 設定 Cookie
        document.cookie = `sca_ref=${scaRef}; path=/; max-age=1,209,600`; // 14天
    }
}


//單一商品-商品特色新增連結功能
document.addEventListener('DOMContentLoaded', function() {
  const accordionContent = document.querySelectorAll('.accordion__content.rte.custom_dropdown');
  
  accordionContent.forEach(function(element) {
    let content = element.innerHTML;
    
    content = content.replace(/&lt;a href=&quot;([^&quot;]*)&quot;&gt;([^&lt;]*)&lt;\/a&gt;/g, '<a href="$1" target="_blank">$2</a>');
    content = content.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
    
    element.innerHTML = content;
  });
});

  (function () {
    document.querySelectorAll('header-menu .mega-menu').forEach((details) => {
      const list = details.querySelector('.mega-menu__list, .mega-menu__list--condensed');
      if (!list) return;

      const items = list.querySelectorAll(':scope > li.mega-menu__item--has-submenu');
      if (!items.length) return;

      function setActive(target) {
        items.forEach((li) => li.classList.toggle('is-active', li === target));

        // 先清掉舊的高度，再重新量測
        list.style.minHeight = '';
        const sub = target && target.querySelector(':scope > ul');
        if (!sub) return;

        requestAnimationFrame(() => {
            const listRect = list.getBoundingClientRect();
            const subRect = sub.getBoundingClientRect();
            const needed = subRect.bottom - listRect.top + 16; // 16px 底部留白
            if (needed > listRect.height) {
            list.style.minHeight = needed + 'px';
            }
        });
        }

      // 選單展開時，預設 active 第一個項目
      details.addEventListener('toggle', () => {
        if (details.open) setActive(items[0]);
      });

      // 滑鼠移到某個第二層項目時，切換 active 到該項目，並保持停留
      items.forEach((li) => {
        li.addEventListener('mouseenter', () => setActive(li));
      });
    });
  })();
  

  customElements.whenDefined('shopify-account').then(() => {
  document.querySelectorAll('shopify-account').forEach((el) => {
    if (!el.shadowRoot) return;
    const style = document.createElement('style');
    style.textContent = ':host{--shopify-account-radius-dialog: 1rem !important;}';
    el.shadowRoot.appendChild(style);
  });
});